import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import mask from './modules/mask';
Vue.use(Vuex);
const store = new Vuex.Store({
	modules:{
		user,
		mask
	}
})


export default store